import React from "react";
import "./allSeeModels.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "mdb-ui-kit/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Input, Ripple, initMDB } from "mdb-ui-kit";
import "@fortawesome/fontawesome-free/css/all.min.css";
import FooterManual from "./footerManual";
import Notes from "./header";
import { Link } from "react-router-dom";
initMDB({ Input, Ripple, initMDB });

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
        backgroundColor: "#1A2027",
    }),
}));

// Comprehensive SVG Icons Library
const SvgIcons = {
    Trophy: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M20.2,2H19.5H18C17.1,2 16,3 16,4H8C8,3 6.9,2 6,2H4.5H3.8H2V11C2,12 3,13 4,13H6.2C6.6,15 7.9,16.7 11,17V19.1C8.8,19.3 8,20.4 8,21.7V22H16V21.7C16,20.4 15.2,19.3 13,19.1V17C16.1,16.7 17.4,15 17.8,13H20C21,13 22,12 22,11V2H20.2M4,11V4H6V6V11C5.1,11 4.3,11 4,11M20,11C19.7,11 18.9,11 18,11V6V4H20V11Z"/>
        </svg>
    ),
    Globe: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
        </svg>
    ),
    Gear: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
        </svg>
    ),
    Heart: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.28 2,8.5C2,5.42 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.09C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.42 22,8.5C22,12.28 18.6,15.36 13.45,20.04L12,21.35Z"/>
        </svg>
    ),
    Car: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z"/>
        </svg>
    ),
    Parts: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,2L9.1,7H3.3L6.3,12L3.3,17H9.1L12,22L14.9,17H20.7L17.7,12L20.7,7H14.9L12,2M12,5L13.2,7H10.8L12,5M8.2,8.5L7.1,10.5L5.5,8.5H8.2M10,12L12,9L14,12L12,15L10,12M7.1,13.5L8.2,15.5H5.5L7.1,13.5M16.9,10.5L15.8,8.5H18.5L16.9,10.5M15.8,15.5L16.9,13.5L18.5,15.5H15.8M13.2,17L12,19L10.8,17H13.2Z"/>
        </svg>
    ),
    Wheel: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z"/>
        </svg>
    ),
    Export: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M9,3L5,7H8V14H10V7H13M12,14A4,4 0 0,1 16,18A4,4 0 0,1 12,22A4,4 0 0,1 8,18A4,4 0 0,1 12,14Z"/>
        </svg>
    ),
    Quality: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5C14.8,13.4 13.4,14 12,14C10.6,14 9.2,13.4 9.2,11.5V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,9.5V11.5C10.5,12.3 11.2,12.8 12,12.8C12.8,12.8 13.5,12.3 13.5,11.5V9.5C13.5,8.7 12.8,8.2 12,8.2Z"/>
        </svg>
    ),
    Support: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M10,4A4,4 0 0,1 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M2,20V18C2,15.88 5.31,14.14 9.5,14C9.18,14.78 9,15.62 9,16.5C9,17.79 9.38,19 10,20H2Z"/>
        </svg>
    ),
    Innovation: () => (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="#d32f2f">
            <path d="M12,2L9.1,7H3.3L6.3,12L3.3,17H9.1L12,22L14.9,17H20.7L17.7,12L20.7,7H14.9L12,2M12,5L13.2,7H10.8L12,5M8.2,8.5L7.1,10.5L5.5,8.5H8.2M10,12L12,9L14,12L12,15L10,12M7.1,13.5L8.2,15.5H5.5L7.1,13.5M16.9,10.5L15.8,8.5H18.5L16.9,10.5M15.8,15.5L16.9,13.5L18.5,15.5H15.8M13.2,17L12,19L10.8,17H13.2Z"/>
        </svg>
    )
};

const AboutUs = () => {
    return (
        <Box
            className="container-main-AllSeeModels"
            sx={{
                position: "relative",
                width: "100%",
                backgroundColor: "#ffffff",
            }}
        >
            <Box sx={{ marginBottom: "0%" }}><Notes /></Box>
            
            {/* Enhanced Hero Section */}
            <Box
                className="hero-section-about"
                sx={{
                    position: "relative",
                    width: "100%",
                    minHeight: { xs: "60vh", sm: "70vh", md: "80vh" },
                    backgroundColor: "#000000",
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src="/image/AllSeeModelsBackgroungCar.png"
                    alt="hero background"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0.3,
                        filter: "grayscale(100%)",
                    }}
                />

                {/* Animated Elements */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "20%",
                        right: { xs: "5%", sm: "8%", md: "10%" },
                        width: { xs: "70px", sm: "100px", md: "120px" },
                        height: { xs: "70px", sm: "100px", md: "120px" },
                        border: "3px solid #d32f2f",
                        borderRadius: "50%",
                        animation: "pulse 2s infinite",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        bottom: "30%",
                        left: { xs: "3%", sm: "5%" },
                        width: { xs: "50px", sm: "70px", md: "80px" },
                        height: { xs: "50px", sm: "70px", md: "80px" },
                        border: "3px solid #d32f2f",
                        borderRadius: "50%",
                        animation: "pulse 3s infinite",
                    }}
                />

                {/* Breadcrumb */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: "10px", sm: "15px", md: "5%" },
                        left: { xs: "10px", sm: "15px", md: "5%" },
                        margin: 0,
                        color: "white",
                        fontSize: { xs: "12px", sm: "14px", md: "15px" },
                        backgroundColor: "rgba(211, 47, 47, 0.9)",
                        padding: { xs: "8px 15px", sm: "10px 20px", md: "12px 25px" },
                        borderRadius: "25px",
                        boxShadow: "0 4px 15px rgba(211,47,47,0.3)",
                        display: { xs: "none", sm: "block" }
                    }}
                >
                    <Typography
                        component="span"
                        sx={{
                            marginRight: "5px",
                        }}
                    >
                        <Link to="https://car.amar.co.jp/" style={{ fontSize: "inherit", color: "white", textDecoration: "none", fontWeight: "600" }}>
                            Home
                        </Link> / About Us
                    </Typography>
                </Box>

                {/* Main Hero Content */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                        color: "white",
                        width: "95%",
                        maxWidth: "1200px",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.5rem", lg: "5rem" },
                            fontWeight: "900",
                            marginBottom: { xs: "15px", sm: "20px", md: "30px" },
                            textTransform: "uppercase",
                            letterSpacing: { xs: "2px", md: "4px" },
                            background: "linear-gradient(45deg, #ffffff 30%, #d32f2f 90%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            color: "transparent",
                            lineHeight: 1.1,
                        }}
                    >
                        Driving Automotive Excellence
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: "0.95rem", sm: "1.2rem", md: "1.5rem", lg: "1.8rem" },
                            fontWeight: "400",
                            opacity: 0.9,
                            maxWidth: "800px",
                            margin: "0 auto",
                            marginBottom: { xs: "20px", sm: "30px", md: "40px" },
                            lineHeight: 1.4,
                        }}
                    >
                        17 Years of Unmatched Quality, Innovation, and Global Trust in Japanese Automotive Excellence
                    </Typography>
                    
                    {/* Hero Stats */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr 1fr" },
                            gap: { xs: "12px", sm: "15px", md: "20px" },
                            marginTop: { xs: "25px", sm: "35px", md: "50px" },
                        }}
                    >
                        {[
                            { number: "17+", text: "Years Experience", icon: <SvgIcons.Trophy /> },
                            { number: "50+", text: "Countries Served", icon: <SvgIcons.Globe /> },
                            { number: "10,000+", text: "Vehicles Exported", icon: <SvgIcons.Car /> },
                            { number: "99%", text: "Customer Satisfaction", icon: <SvgIcons.Heart /> }
                        ].map((stat, index) => (
                            <Box
                                key={index}
                                sx={{
                                    backgroundColor: "rgba(255,255,255,0.1)",
                                    padding: { xs: "15px 10px", sm: "20px 15px", md: "25px 15px" },
                                    borderRadius: "15px",
                                    backdropFilter: "blur(10px)",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        backgroundColor: "rgba(211,47,47,0.2)",
                                    },
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: "10px", md: "15px" }, display: "flex", justifyContent: "center" }}>
                                    <Box sx={{ width: { xs: "35px", md: "50px" }, height: { xs: "35px", md: "50px" } }}>
                                        {stat.icon}
                                    </Box>
                                </Box>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
                                        fontWeight: "900",
                                        color: "#d32f2f",
                                        marginBottom: "8px",
                                    }}
                                >
                                    {stat.number}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                                        color: "#ffffff",
                                        fontWeight: "600",
                                    }}
                                >
                                    {stat.text}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>

            {/* Comprehensive Content Sections */}
            <Box sx={{ width: "100%", backgroundColor: "#ffffff", position: "relative" }}>

                {/* Company Story Section */}
                <Box
                    sx={{
                        width: { xs: "95%", sm: "90%" },
                        margin: { xs: "50px auto 40px", sm: "80px auto 60px", md: "100px auto 60px" },
                        padding: { xs: "30px 20px", sm: "50px 30px", md: "80px 50px" },
                        backgroundColor: "#000000",
                        borderRadius: { xs: "15px", md: "25px" },
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                            gap: { xs: "30px", sm: "40px", md: "60px" },
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                                    fontWeight: "900",
                                    color: "#d32f2f",
                                    marginBottom: { xs: "20px", md: "30px" },
                                    lineHeight: 1.1,
                                }}
                            >
                                OUR LEGACY OF AUTOMOTIVE EXCELLENCE
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.2rem" },
                                    color: "#ffffff",
                                    lineHeight: 1.8,
                                    marginBottom: { xs: "20px", md: "30px" },
                                    opacity: 0.9,
                                }}
                            >
                                Since 2007, <strong>Amar Enterprises</strong> has been at the forefront of revolutionizing the automotive export industry. With 17 years of unwavering commitment, we have established ourselves as a trusted global partner for Japanese used cars, auto parts, tires, wheels, and scrap materials.
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.2rem" },
                                    color: "#ffffff",
                                    lineHeight: 1.8,
                                    marginBottom: { xs: "20px", md: "40px" },
                                    opacity: 0.9,
                                }}
                            >
                                Our journey began with a simple vision: to make quality Japanese automotive products accessible worldwide while maintaining the highest standards of service and reliability. Today, we serve clients in over 50 countries, having successfully exported more than 10,000 vehicles and countless automotive components.
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: { xs: "10px", md: "20px" },
                                    flexWrap: "wrap",
                                }}
                            >
                                <Box
                                    sx={{
                                        padding: { xs: "12px 25px", md: "15px 35px" },
                                        backgroundColor: "#d32f2f",
                                        color: "white",
                                        borderRadius: "25px",
                                        fontWeight: "700",
                                        fontSize: { xs: "0.85rem", md: "1rem" },
                                        textTransform: "uppercase",
                                        letterSpacing: "1px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            backgroundColor: "#b71c1c",
                                            transform: "translateY(-3px)",
                                            boxShadow: "0 10px 25px rgba(211,47,47,0.3)",
                                        },
                                    }}
                                >
                                    Explore Our Journey
                                </Box>
                                <Box
                                    sx={{
                                        padding: { xs: "12px 25px", md: "15px 35px" },
                                        backgroundColor: "transparent",
                                        color: "#ffffff",
                                        border: "2px solid #d32f2f",
                                        borderRadius: "25px",
                                        fontWeight: "700",
                                        fontSize: { xs: "0.85rem", md: "1rem" },
                                        textTransform: "uppercase",
                                        letterSpacing: "1px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            backgroundColor: "#d32f2f",
                                            transform: "translateY(-3px)",
                                        },
                                    }}
                                >
                                    View Our Gallery
                                </Box>
                            </Box>
                        </Box>
                        
                        <Box
                            sx={{
                                position: "relative",
                                height: { xs: "300px", sm: "400px", md: "500px" },
                                backgroundColor: "#1a1a1a",
                                borderRadius: "20px",
                                overflow: "hidden",
                                border: "3px solid #333",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#666",
                                fontSize: { xs: "1rem", md: "1.2rem" },
                            }}
                        >
                            [Company Timeline & Achievement Visualization]
                        </Box>
                    </Box>
                </Box>

                {/* Enhanced Services Section */}
                <Box
                    sx={{
                        width: { xs: "95%", sm: "90%" },
                        margin: { xs: "50px auto", sm: "80px auto", md: "100px auto" },
                    }}
                >
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                            fontWeight: "900",
                            color: "#000000",
                            marginBottom: { xs: "40px", md: "80px" },
                            position: "relative",
                            "&::after": {
                                content: '""',
                                position: "absolute",
                                bottom: { xs: "-10px", md: "-20px" },
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "150px",
                                height: "6px",
                                backgroundColor: "#d32f2f",
                                borderRadius: "3px",
                            },
                        }}
                    >
                        OUR COMPREHENSIVE SERVICES
                    </Typography>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                            gap: { xs: "20px", sm: "30px", md: "40px" },
                            marginBottom: { xs: "40px", md: "80px" },
                        }}
                    >
                        {[
                            {
                                icon: <SvgIcons.Car />,
                                title: "New & Used Cars",
                                description: "Discover excellence in motion with our curated selection of Japanese new and used cars. We offer vehicles that perfectly merge style, performance, and reliability. From compact city cars to luxury sedans and robust SUVs, our inventory is carefully selected to meet diverse customer needs and preferences.",
                                features: ["300+ Vehicles in Stock", "Full Inspection Reports", "Export Documentation", "Shipping Worldwide"]
                            },
                            {
                                icon: <SvgIcons.Parts />,
                                title: "Automobile Parts",
                                description: "Drive with absolute confidence using our premium automobile parts collection. Each component is precision-engineered for peak performance and reliability. We source genuine Japanese parts that guarantee optimal performance and longevity for your vehicles.",
                                features: ["Genuine Japanese Parts", "Quality Assurance", "Wide Range Available", "Global Shipping"]
                            },
                            {
                                icon: <SvgIcons.Wheel />,
                                title: "Wheels & Tires",
                                description: "Revolutionize your ride with our high-quality wheels and premium tires. The perfect blend of aesthetics, precision engineering, and performance for every journey. Our collection includes alloy wheels, steel wheels, and performance tires from top Japanese brands.",
                                features: ["Alloy & Steel Wheels", "Performance Tires", "Complete Sets Available", "Quality Certified"]
                            },
                            {
                                icon: <SvgIcons.Export />,
                                title: "Import & Export",
                                description: "Global connections with local expertise. Seamlessly import and export with us as we unlock international trade opportunities, ensuring a smooth journey for your goods. Our logistics network spans across continents with efficient handling.",
                                features: ["50+ Countries", "Customs Clearance", "Logistics Support", "Documentation Handling"]
                            }
                        ].map((service, index) => (
                            <Box
                                key={index}
                                sx={{
                                    padding: { xs: "25px 20px", sm: "40px 30px", md: "50px 40px" },
                                    backgroundColor: "#ffffff",
                                    borderRadius: "20px",
                                    border: "3px solid #d32f2f",
                                    textAlign: "center",
                                    transition: "all 0.3s ease",
                                    position: "relative",
                                    overflow: "hidden",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                                    "&:hover": {
                                        transform: "translateY(-15px)",
                                        boxShadow: "0 25px 50px rgba(211,47,47,0.15)",
                                    },
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: "15px", md: "25px" }, display: "flex", justifyContent: "center" }}>
                                    <Box sx={{ width: { xs: "40px", md: "50px" }, height: { xs: "40px", md: "50px" } }}>
                                        {service.icon}
                                    </Box>
                                </Box>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
                                        fontWeight: "800",
                                        color: "#000000",
                                        marginBottom: { xs: "15px", md: "25px" },
                                    }}
                                >
                                    {service.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                                        color: "#666",
                                        lineHeight: 1.7,
                                        marginBottom: { xs: "20px", md: "30px" },
                                        textAlign: "left",
                                    }}
                                >
                                    {service.description}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: { xs: "10px", md: "15px" },
                                        textAlign: "left",
                                    }}
                                >
                                    {service.features.map((feature, idx) => (
                                        <Box
                                            key={idx}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: "8px",
                                                    height: "8px",
                                                    backgroundColor: "#d32f2f",
                                                    borderRadius: "50%",
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontSize: { xs: "0.85rem", md: "0.95rem" },
                                                    color: "#333",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                {feature}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* Why Choose Us - Detailed Section */}
                <Box
                    sx={{
                        width: "100%",
                        backgroundColor: "#f8f9fa",
                        padding: { xs: "50px 0", sm: "80px 0", md: "100px 0" },
                        margin: { xs: "50px 0", sm: "80px 0", md: "100px 0" },
                    }}
                >
                    <Box sx={{ width: { xs: "95%", sm: "90%" }, margin: "0 auto" }}>
                        <Typography
                            sx={{
                                textAlign: "center",
                                fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                                fontWeight: "900",
                                color: "#000000",
                                marginBottom: { xs: "40px", md: "80px" },
                                position: "relative",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: { xs: "-10px", md: "-20px" },
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: "150px",
                                    height: "6px",
                                    backgroundColor: "#d32f2f",
                                    borderRadius: "3px",
                                },
                            }}
                        >
                            WHY AMAR ENTERPRISES STANDS OUT
                        </Typography>

                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
                                gap: { xs: "20px", sm: "30px", md: "40px" },
                            }}
                        >
                            {[
                                {
                                    icon: <SvgIcons.Quality />,
                                    title: "Highest Quality Standards",
                                    description: "We maintain the highest quality standards by consistently delivering superior products and services that exceed industry benchmarks. Every vehicle and part undergoes rigorous inspection and quality control processes.",
                                    details: ["17-Point Vehicle Inspection", "Genuine Parts Verification", "Quality Certification", "Performance Testing"]
                                },
                                {
                                    icon: <SvgIcons.Support />,
                                    title: "Customer Service Focus",
                                    description: "Prioritizing customer satisfaction through timely support, personalized service, and exceeding expectations at every touchpoint. Our dedicated support team is available 24/7 to assist you.",
                                    details: ["24/7 Customer Support", "Multi-language Support", "After-sales Service", "Customer Feedback System"]
                                },
                                {
                                    icon: <SvgIcons.Innovation />,
                                    title: "Innovation Driven Process",
                                    description: "We utilize advanced systems-driven processes to optimize efficiency, reduce errors, and increase productivity while maintaining the highest standards of service delivery.",
                                    details: ["Digital Inventory Management", "Automated Quality Checks", "Real-time Tracking", "Process Optimization"]
                                }
                            ].map((feature, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        padding: { xs: "25px 20px", sm: "40px 30px", md: "50px 35px" },
                                        backgroundColor: "#ffffff",
                                        borderRadius: "20px",
                                        textAlign: "center",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                                        border: "2px solid transparent",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            transform: "translateY(-10px)",
                                            borderColor: "#d32f2f",
                                            boxShadow: "0 20px 40px rgba(211,47,47,0.15)",
                                        },
                                    }}
                                >
                                    <Box sx={{ marginBottom: { xs: "15px", md: "25px" }, display: "flex", justifyContent: "center" }}>
                                        <Box sx={{ width: { xs: "40px", md: "50px" }, height: { xs: "40px", md: "50px" } }}>
                                            {feature.icon}
                                        </Box>
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "1.2rem", sm: "1.3rem", md: "1.5rem" },
                                            fontWeight: "800",
                                            color: "#000000",
                                            marginBottom: { xs: "15px", md: "20px" },
                                        }}
                                    >
                                        {feature.title}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "0.95rem", md: "1rem" },
                                            color: "#666",
                                            lineHeight: 1.7,
                                            marginBottom: { xs: "15px", md: "25px" },
                                            textAlign: "left",
                                        }}
                                    >
                                        {feature.description}
                                    </Typography>
                                    <Box sx={{ textAlign: "left" }}>
                                        {feature.details.map((detail, idx) => (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: "6px",
                                                        height: "6px",
                                                        backgroundColor: "#d32f2f",
                                                        borderRadius: "50%",
                                                        flexShrink: 0,
                                                    }}
                                                />
                                                <Typography
                                                    sx={{
                                                        fontSize: { xs: "0.85rem", md: "0.95rem" },
                                                        color: "#333",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    {detail}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>

                {/* Global Presence Section */}
                <Box
                    sx={{
                        width: { xs: "95%", sm: "90%" },
                        margin: { xs: "50px auto", sm: "80px auto", md: "100px auto" },
                        padding: { xs: "30px 20px", sm: "50px 30px", md: "80px 50px" },
                        backgroundColor: "#000000",
                        borderRadius: { xs: "15px", md: "25px" },
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: "1.8rem", sm: "2.3rem", md: "3rem" },
                            fontWeight: "900",
                            color: "#d32f2f",
                            marginBottom: { xs: "10px", md: "20px" },
                        }}
                    >
                        GLOBAL REACH, LOCAL IMPACT
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
                            color: "#ffffff",
                            marginBottom: { xs: "30px", md: "50px" },
                            opacity: 0.9,
                        }}
                    >
                        Serving clients across 6 continents with unmatched Japanese automotive quality
                    </Typography>
                    
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr 1fr", md: "1fr 1fr 1fr 1fr 1fr 1fr" },
                            gap: { xs: "15px", sm: "20px", md: "30px" },
                            marginBottom: { xs: "30px", md: "50px" },
                        }}
                    >
                        {["North America", "Europe", "Asia", "Africa", "Australia", "Middle East"].map((region, index) => (
                            <Box
                                key={index}
                                sx={{
                                    padding: { xs: "15px 10px", md: "25px 15px" },
                                    backgroundColor: "rgba(255,255,255,0.1)",
                                    borderRadius: "15px",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: { xs: "0.95rem", md: "1.1rem" },
                                        color: "#ffffff",
                                        fontWeight: "600",
                                    }}
                                >
                                    {region}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    <Typography
                        sx={{
                            fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                            color: "#ffffff",
                            opacity: 0.8,
                            maxWidth: "800px",
                            margin: "0 auto",
                            lineHeight: 1.6,
                        }}
                    >
                        With strategic partnerships and logistics networks spanning the globe, we ensure timely delivery and exceptional service regardless of your location. Our multilingual team understands local markets and customs requirements, making international trade seamless and efficient.
                    </Typography>
                </Box>

                {/* Final Commitment Section */}
                <Box
                    sx={{
                        width: { xs: "95%", sm: "90%" },
                        margin: { xs: "50px auto", sm: "80px auto", md: "100px auto" },
                        textAlign: "center",
                        padding: { xs: "30px 20px", sm: "50px 30px", md: "80px 50px" },
                        backgroundColor: "#ffffff",
                        borderRadius: { xs: "15px", md: "25px" },
                        border: "3px solid #d32f2f",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.5rem" },
                            fontWeight: "900",
                            color: "#000000",
                            marginBottom: { xs: "20px", md: "30px" },
                        }}
                    >
                        YOUR TRUSTED AUTOMOTIVE PARTNER
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" },
                            color: "#666",
                            marginBottom: { xs: "30px", md: "50px" },
                            maxWidth: "900px",
                            margin: "0 auto",
                            marginBottom: { xs: "30px", md: "50px" },
                            lineHeight: 1.7,
                        }}
                    >
                        With nearly two decades of experience, Amar Enterprises stands as a beacon of reliability in the automotive sector. Our customer-centric approach, coupled with a diverse range of services and unwavering commitment to excellence, sets us apart as a leading force in the global automotive industry.
                    </Typography>
                    
                    <Box
                        sx={{
                            display: "flex",
                            gap: { xs: "12px", sm: "20px", md: "25px" },
                            justifyContent: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                padding: { xs: "14px 25px", md: "18px 40px" },
                                backgroundColor: "#d32f2f",
                                color: "white",
                                borderRadius: "25px",
                                fontWeight: "700",
                                fontSize: { xs: "0.85rem", md: "1.1rem" },
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    backgroundColor: "#b71c1c",
                                    transform: "translateY(-3px)",
                                    boxShadow: "0 15px 30px rgba(211,47,47,0.4)",
                                },
                            }}
                        >
                            Start Your Journey
                        </Box>
                        <Box
                            sx={{
                                padding: { xs: "14px 25px", md: "18px 40px" },
                                backgroundColor: "transparent",
                                color: "#000000",
                                border: "3px solid #d32f2f",
                                borderRadius: "25px",
                                fontWeight: "700",
                                fontSize: { xs: "0.85rem", md: "1.1rem" },
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    backgroundColor: "#d32f2f",
                                    color: "white",
                                    transform: "translateY(-3px)",
                                },
                            }}
                        >
                            Contact Our Experts
                        </Box>
                    </Box>
                </Box>
            </Box>

            <FooterManual />
        </Box>
    );
};

export default AboutUs;